import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { RouteProps } from 'react-router';
import Bubble, { BubbleType } from '../../components/bubble/bubble';
import Image, { ImageType } from '../../components/image/image';
import Container from '../../components/layout/container';
import messages from './messages';
import Button, { ButtonType } from '../../components/button/button';
import { ROUTE_LOGIN } from '../../RouteList';
class SingaporeFinished extends React.Component<RouteProps & any, any> {
  public render() {
    const {
      dataStore: { reset },
      routing: { push },
      intl
    } = this.props;

    return (
      <Container>
        <Bubble type={BubbleType.Right}>
          <p className={classNames('c-bubble__content')}>
            <FormattedMessage {...messages.singaporefinishedDescription} />
          </p>
          <Button
            onClick={() => {
              reset();
              push(ROUTE_LOGIN);
            }}
            type={ButtonType.primary}
            label={intl.formatMessage(messages.singaporefinishedButton)}
          />
        </Bubble>
        <div className={classNames('c-image--wrapper')}>
          <Image
            type={ImageType.fittingKleermaker}
            imgSrc="/images/svg/fitting-kleermaker.svg"
            alt={'Sporti'}
          />
          <Image
            type={ImageType.fittingSuits}
            imgSrc="/images/svg/fitting-suits.svg"
            alt={'Rocket'}
          />
        </div>
      </Container>
    );
  }
}

export default inject(
  'dataStore',
  'routing'
)(injectIntl(observer(SingaporeFinished)));



// WEBPACK FOOTER //
// ./src/containers/singaporefinished/SingaporeFinished.tsx